<template>
  <div id="app"
       class="page-root l-canvas titlebar_none"
       :class="selector"
  >
    <TheHeader/>
    <div class="l-main">
      <transition name="fade" mode="out-in" @before-enter="onEnter" appear>
        <router-view class="l-main-h i-cf"/>
      </transition>
    </div>
    <TheFooter/>
    <TheSvgList/>
  </div>
</template>

<script>
  import TheHeader from '../components/TheHeader'
  import TheFooter from '../components/TheFooter'
  import TheSvgList from '../components/TheSvgList'

  export default {
    components: {
      TheFooter,
      TheHeader,
      TheSvgList
    },
    computed: {
      selector() {
        return {
          'sidebar_none': !this.$route.meta.sidebar,
          'sidebar_right': this.$route.meta.sidebar
        }
      }
    },
    methods: {
      onEnter() {
        this.$root.$emit("beforeEnter");
      }
    },
    mounted() {
      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        document.documentElement.classList.add('no-touch')
      }
    }
  }
</script>
